import React from 'react';

import logo from '../../../images/logo_medium.svg';

import { FOHImage } from '../../ingredients';

export const FOHLogoMedium = () => (
  <FOHImage source={{ uri: logo }} style={{ width: 92, height: 18 }} />
);
